export { AuthService } from './src';
export { PublicGuard } from './src';
export { ProtectedGuard } from './src';
export { AUTH_SERVICE, PUBLIC_FALLBACK_PAGE_URI, PROTECTED_FALLBACK_PAGE_URI } from './src';
export { AuthModule } from './src';



// WEBPACK FOOTER //
// ./~/ngx-auth/index.ts